import { Grid } from "@mui/material";
import keyLabel from "../../../../utils/keylabel";
import PrioritySlider from "../FormFields/PrioritySlider";
import AutocompletePatient from "../FormFields/AutocompletePatient";
import { InputField, SelectField } from "../../../../utils/FormFields";
import DurationPicker from "../../../../utils/FormFields/DurationPicker";
import { AppointmentStatusEnum } from "../../../../api/medical-operations";
import BasicDateTimePicker from "../../../../utils/FormFields/BasicDateTimePicker";
import AutocompleteDoctor from "../../../Payment/Bills/PatientBills/FormModel/AutocompleteDoctor";

const CreateAppointmentStatusEnum = {
  Scheduled: "Scheduled",
  PendingFollowup: "Pending Followup",
};
const statusForCreate = keyLabel(CreateAppointmentStatusEnum);
const status = keyLabel(AppointmentStatusEnum);

type Props = {
  isEdit?: boolean;
  isAdd?: boolean;
  isCreating?: boolean;
  isClosed?: boolean;
  onCalendar?: boolean;
};

const AppointmentForm = ({ isEdit, isAdd, isCreating, isClosed, onCalendar }: Props) => {
  return (
    <>
      <Grid
        container
        rowSpacing={4}
        spacing={2}
        sx={{
          pt: 8,
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        {isEdit || isAdd ? null : (
          <Grid item xs={12} sm={6}>
            <AutocompletePatient name="PatientID" />
          </Grid>
        )}
        <Grid container />

        {isEdit || isAdd ? null : (
          <Grid item xs={12} sm={6} >
            <AutocompleteDoctor name="EmployeeID" />
          </Grid>        
        )}  
        <Grid container />

        <Grid item xs={12} sm={6}>
          <InputField name="ConsultationReason" label="Consultation Reason" disabled={isClosed} fullWidth />
        </Grid>
        <Grid container />
        {isCreating ? (
          <Grid item xs={12} sm={6}>
            <SelectField name="Status" label="Status" data={statusForCreate} type={CreateAppointmentStatusEnum} fullWidth />
          </Grid>
        ) : (
          <Grid item xs={12} sm={6}>
            <SelectField name="Status" label="Status" data={status} type={AppointmentStatusEnum} disabled={isClosed} fullWidth />
          </Grid>
        )}
        <Grid container />
        {onCalendar ? (
          <Grid item xs={12} sm={3}>
            <BasicDateTimePicker label="Date" name="DateFrom" disabled={true}/>
          </Grid>
        ) : (
          <Grid item xs={12} sm={3}>
            <BasicDateTimePicker label="Date" name="DateFrom" disabled={isClosed}/>
          </Grid>
        )}
        <Grid item xs={12} sm={3}>
          <DurationPicker label="Duration in minutes" name="Duration" disabled={isClosed}/>
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={6}>
          <PrioritySlider id="priority-slider" name="Priority" label="Priority" disabled={isClosed}/>
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={6}>
          <InputField name="Notes" label="Notes" multiline rows={4} fullWidth variant="filled" disabled={isClosed}/>
        </Grid>
      </Grid>
    </>
  );
};

export default AppointmentForm;
